<!-- by 7527189 2 0 -->
<template>

  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <a-radio-group v-model="mode" :style="{ marginBottom: '8px' }">
          <a-radio-button value="old">
            V1.2.0之前
          </a-radio-button>
          <a-radio-button value="new">
            V1.2.0之后
          </a-radio-button>
        </a-radio-group>
        <returnGoodslistNew class="child" v-if="mode == 'new'"></returnGoodslistNew>
        <returnGoodslistOld class="child" v-else></returnGoodslistOld>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>

import { JeecgListMixin } from '@/mixins/JeecgListMixin'

import returnGoodslistNew from './returnGoodslistNew'
import returnGoodslistOld from './returnGoodslistOld'
export default {
  name: 'MaterialList',
  mixins: [JeecgListMixin],
  components: {
    returnGoodslistNew,
    returnGoodslistOld,

  },
  data () {
    return {
      mode:'new',
    }
  },
  created () {

  },
  computed: {

  },
  methods: {

  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';

.elementButtonText {
  color: #409eff;
  cursor: pointer;
}

</style>
<style>
.child{
  margin-left: -36px !important;
  margin-right: -36px !important;
}
</style>